import React from "react";
import { Dialog } from "@headlessui/react";
import { X } from "lucide-react";

interface ProfessionalRequirementsDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

const ProfessionalRequirementsDialog: React.FC<ProfessionalRequirementsDialogProps> = ({ isOpen, onClose }) => {
    return (
        <Dialog open={isOpen} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4 bg-black bg-opacity-30">
                <Dialog.Panel className="w-full max-w-2xl rounded-2xl bg-white p-8 shadow-xl">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                        <Dialog.Title className="text-xl font-semibold text-gray-900">
                            Professional Requirements
                        </Dialog.Title>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 transition-colors">
                            <X className="w-6 h-6" />
                        </button>
                    </div>

                    {/* Content */}
                    <div className="space-y-6 text-center">
                        <p className="text-gray-700 leading-relaxed">
                            All professionals must possess the necessary qualifications, certifications, and experience 
                            required for their respective fields. This includes relevant educational background, 
                            professional licenses, and demonstrated expertise in their area of specialization.
                        </p>
                        
                        <p className="text-gray-700 leading-relaxed">
                            Professionals are expected to maintain high standards of ethical conduct, 
                            continuous learning, and professional development. They must stay current with 
                            industry best practices and regulatory requirements applicable to their profession.
                        </p>
                        
                        <p className="text-gray-700 leading-relaxed">
                            By declaring possession of these professional requirements, you confirm that you meet 
                            all necessary standards and are qualified to provide services in your chosen field 
                            according to industry standards and legal requirements.
                        </p>
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end mt-8">
                        <button
                            onClick={onClose}
                            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                            I Understand
                        </button>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
};

export default ProfessionalRequirementsDialog;
